function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { styled as muiStyled } from '@mui/material/styles';
import { List, ListItem, ListItemText, Slide } from '@mui/material';
import { SIZES } from '@fupa/fupa-uikit';
import { Dialog } from 'app/components/dialog/Dialog';
import { LinkOnComponent } from 'app/components/links/link';
const CustomDialog = muiStyled(Dialog)(_ref => {
  let {
    theme
  } = _ref;
  return {
    '& .MuiDialog-container': {
      [theme.breakpoints.down('sm')]: {
        alignItems: 'flex-end'
      }
    },
    '& .MuiPaper-root': {
      margin: 0,
      padding: SIZES['8'],
      width: '100%',
      transition: 'height 0.1s',
      maxHeight: '100%'
    }
  };
});
const Transition = /*#__PURE__*/React.forwardRef(function Transition(props, ref) {
  return /*#__PURE__*/React.createElement(Slide, _extends({
    direction: "up",
    ref: ref
  }, props, {
    children: props.children
  }));
});
const ClubShortcutSyndicateTeamDialog = _ref2 => {
  let {
    open,
    onClose,
    teams
  } = _ref2;
  const items = teams.map(team => /*#__PURE__*/React.createElement(ListItem, {
    key: "item-".concat(team.clubId),
    component: LinkOnComponent,
    to: "/club/".concat(team.clubSlug)
  }, /*#__PURE__*/React.createElement(ListItemText, {
    primary: "\uD83D\uDD17 ".concat(team.names.full)
  })));
  return /*#__PURE__*/React.createElement(CustomDialog, {
    TransitionComponent: Transition,
    closeable: true,
    actionContent: /*#__PURE__*/React.createElement("div", null),
    handleClose: onClose,
    open: open,
    title: "Links",
    "data-sentry-element": "CustomDialog",
    "data-sentry-component": "ClubShortcutSyndicateTeamDialog",
    "data-sentry-source-file": "clubShortcutSyndicateTeamDialog.tsx"
  }, /*#__PURE__*/React.createElement(List, {
    "data-sentry-element": "List",
    "data-sentry-source-file": "clubShortcutSyndicateTeamDialog.tsx"
  }, items));
};
export default ClubShortcutSyndicateTeamDialog;